import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=8c85a954&scoped=true"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ChangePassword.vue?vue&type=style&index=0&id=8c85a954&prod&scoped=true&lang=css"
import style1 from "./ChangePassword.vue?vue&type=style&index=1&id=8c85a954&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c85a954",
  null
  
)

export default component.exports